import React from 'react'
import './Loader.css'

function Loader() {
    return (
    <div className='preload'>
        <img className='airplane' src='/images/hanuman.png' alt='Hanuman'/>
        <h3>Landing on the website!!</h3>
        <img className='cloud1' src='/images/cloud.png' alt='cloud'/>
        <img className='cloud2' src='/images/cloud.png' alt='cloud'/>
        <img className='cloud3' src='/images/cloud.png' alt='cloud'/>
    </div>
    )
}

export default Loader
